import { useState } from "react";

const besiList = {
  bird: [
    "Zwarte stern",
    "Glanskop",
    "Grote lijster",
    "Wilde eend",
    "Blauwe reiger",
    "Roodborst",
    "Zwartkopmeeuw",
    "Huiszwaluw",
    "Krekelzanger",
    "Roerdomp",
    "Fitis",
    "Boomklever",
    "Krooneend",
    "Kuifmees",
    "Vuurgoudhaan",
    "Bonte vliegenvanger",
    "Grutto",
    "Groenling",
    "Boomleeuwerik",
    "Meerkoet",
    "Heggenmus",
    "Staartmees",
    "Kleine karekiet",
    "Tapuit",
    "Zwarte mees",
    "Dodaars",
    "Grauwe gans",
    "Gele kwikstaart",
    "Grote bonte specht",
    "Kleine mantelmeeuw",
    "Kleine bonte specht",
    "Groene specht",
    "Winterkoning",
    "Ringmus",
    "Eider",
    "Rietgors",
    "Roek",
    "Knobbelzwaan",
    "Wintertaling",
    "Vink",
    "Fuut",
    "Brandgans",
    "Grote gele kwikstaart",
    "Smient",
    "Pimpelmees",
    "Tafeleend",
    "Tuinfluiter",
    "Paapje",
    "Oeverzwaluw",
    "Bosrietzanger",
    "Kneu",
    "Kluut",
    "Snor",
    "Bergeend",
    "Tureluur",
    "Bosuil",
    "Kievit",
    "Brilduiker",
    "Tjiftjaf",
    "Houtsnip",
    "Rietzanger",
    "Boerenzwaluw",
    "Grasmus",
    "Gaai",
    "Zwarte roodstaart",
    "Taigaboomkruiper",
    "Kleine zilverreiger",
    "Blauwborst",
    "Grote zilverreiger",
    "Spreeuw",
    "Grauwe gors",
    "Middelste bonte specht",
    "Huismus",
    "Zomertortel",
    "Scholekster",
    "Boompieper",
    "Gierzwaluw",
    "Matkop",
    "Waterhoen",
    "Zilvermeeuw",
    "Slobeend",
    "Roodmus",
    "Kokmeeuw",
    "Baardman",
    "Orpheusspotvogel",
    "Braamsluiper",
    "Oeverloper",
    "Roodhalsfuut",
    "Fluiter",
    "Zanglijster",
    "Turkse tortel",
    "Goudhaan",
    "Wulp",
    "Patrijs",
    "Watersnip",
    "Kwartel",
    "Stormmeeuw",
    "Waterral",
    "Ooievaar",
    "Geoorde fuut",
    "Sprinkhaanzanger",
    "Geelgors",
    "Boomkruiper",
    "Ekster",
    "Holenduif",
    "Roodborsttapuit",
    "Pijlstaart",
    "Veldleeuwerik",
    "Cetti's Zanger",
    "Zomertaling",
    "Kauw",
    "Zwartkop",
    "Gekraagde roodstaart",
    "Graspieper",
    "Kolgans",
    "Kramsvogel",
    "Nachtegaal",
    "Aalscholver",
    "Graszanger",
    "Koolmees",
    "Grote mantelmeeuw",
    "Merel",
    "Appelvink",
    "Witte kwikstaart",
    "Middelste zaagbek",
    "Bonte strandloper",
    "Houtduif",
    "Krakeend",
    "Kuifeend",
    "Spotvogel",
    "Zwarte kraai",
    "Visdief",
    "Koekoek",
    "Grauwe vliegenvanger",
    "Kleine plevier",
  ],
  mammal: [
    "Hermelijn",
    "Vos",
    "Haas",
    "Bunzing",
    "Steenmarter",
    "Bosmuis",
    "Aardmuis",
    "Dwergmuis",
    "Gebouwbewonende vleermuizen",
    "Waterspitsmuis",
    "Noordse woelmuis",
    "Gewone bosspitsmuis",
    "Otter",
    "Konijn",
    "Boombewonende vleermuizen",
    "Damhert",
    "Dwergspitsmuis",
    "Ree",
    "Huisspitsmuis",
    "Wezel",
    "Edelhert",
    "Ondergrondse woelmuis",
    "Egel",
    "Grote bosmuis",
    "Eekhoorn",
    "Rosse woelmuis",
    "Veldmuis",
  ],
  insect: [
    "Grote weerschijnvlinder",
    "Rode koekoekshommel",
    "Beekrombout",
    "Brachycentrus subnubilus",
    "Heidehommel",
    "Gevlekte witsnuitlibel",
    "Grote parelmoervlinder",
    "Iepenpage",
    "Boswitje",
    "Zwavelhaft",
    "Koolzwarte zandbij",
    "Knautiabij",
    "Geelsprietdikkopje",
    "Grammotaulius nitidus",
    "Zandhommel",
    "Noordse winterjuffer",
    "Weidesprinkhaan",
    "Dreps",
    "Kleine ijsvogelvlinder",
    "Grammotaulius nigropunctatus",
    "Kempense heidelibel",
    "Bruin dikkopje",
    "Vierbandgroefbij",
    "Zilveren zandbij",
    "Limnephilus elegans",
    "Rivierrombout",
    "Gaffellibel",
    "Gestreepte waterroofkever",
    "Gevlekte glanslibel",
    "Bosparelmoervlinder",
    "Stenophylax permistus",
    "Bosbeekjuffer",
    "Teunisbloempijlstaart",
    "Hydroptila sparsa",
    "Groene glazenmaker",
    "Veldparelmoervlinder",
    "Gele tubebij",
    "Athripsodes albifrons",
    "Vierlijneendagsvlieg",
    "Blauwzwarte houtbij",
    "Sierlijke witsnuitlibel",
    "Klaverblauwtje",
    "Moshommel",
    "Roodrandzandbij",
    "Kommavlinder",
    "Spaanse vlag",
    "Sleedoornpage",
    "Kustbehangersbij",
    "Limnephilus stigma",
    "Duinparelmoervlinder",
    "Bruine eikenpage",
    "Kalketrip",
    "Ceraclea albimacula",
    "Zwarte sachembij",
  ],
  amphibian: [
    "Vinpootsalamander",
    "Alpenwatersalamander",
    "Levendbarende hagedis",
    "Hazelworm",
    "Zandhagedis",
    "Rugstreeppad",
    "Heikikker",
    "Kleine watersalamander",
    "Ringslang",
    "Meerkikker",
    "Bruine kikker",
    "Bastaardkikker",
    "Gewone pad",
    "Poelkikker",
  ],
  fish: ["Elrits", "Kwabaal", "Bittervoorn", "Fint", "Kleine modderkruiper", "Grote modderkruiper"],
  plant: [
    "Muurbloem",
    "Naaldenkervel",
    "Wilde averuit",
    "Brede wolfsmelk",
    "Glad biggenkruid",
    "Zandwolfsmelk",
    "Blaasvaren",
    "Getande veldsla",
    "Tengere veldmuur",
    "Korensla",
    "Kruipend moerasscherm",
    "Naakte lathyrus",
    "Kleine wolfsmelk",
    "Stijve wolfsmelk",
    "Tengere distel",
    "Ruw parelzaad",
    "Knolspirea",
    "Groot spiegelklokje",
    "Akkerboterbloem",
    "Wilde ridderspoor",
    "Spits havikskruid",
    "Pijlscheefkelk",
    "Akkerogentroost",
    "Schubvaren",
    "Drijvende waterweegbree",
    "Grote bosaardbei",
    "Blauw guichelheil",
    "Akkerdoornzaad",
    "Grote leeuwenklauw",
    "Liggende ereprijs",
  ],
  grass: ["Schubzegge", "Smalle raai"],
  invert: ["Zeggekorfslak", "Platte schijfhoren"],
};
const translate = {
  bird: "Vogel",
  amphibian: "Amfibie",
  mammal: "Zoogdier",
  fish: "Vis",
  plant: "Plant",
  grass: "Gras",
  invert: "Ongewervelde",
  insect: "Insect",
};

const mapping = {};
for (const [group, values] of Object.entries(besiList)) {
  for (const value of values) {
    mapping[value] = group;
  }
}
// Use the new elegant outline icon set
import { MoreToggle } from "../../../components/MoreToggle";
import spriteMarkup from "./besi.svg?raw";

// Een <use href="bestand.svg#id"> mag alleen naar hetzelfde domein wijzen, en
// er is geen CORS-uitzondering voor. Lokaal komt de sprite van de Vite-server
// en staat de pagina op Django, dus die verwijzing blokkeert de browser. De
// sprite één keer in het document zetten houdt de verwijzing document-intern.
const spriteSymbols = spriteMarkup.replace(/<\?xml[^>]*\?>/, "");

const SoortToggle = ({ data }: { data: { [key: string]: string[] } }) => {
  const [active, setActive] = useState(0);
  const [open, setOpen] = useState(false);

  const [activeGroup, activeList] = Object.entries(data)[active];
  const shorten = activeList?.length > 5;
  const lst = shorten && !open ? activeList.slice(0, 5) : activeList;
  return (
    <div>
      {Object.keys(data).map((group, index) => (
        <span
          key={index}
          className="inline-block mr-2"
          title={translate[group]}
          onClick={() => setActive(index)}
        >
          <svg viewBox="0 0 24 24" className={`w-8 h-8 ${index === active && "bg-yellow"}`}>
            <use href={`#icon-${group}`} />
          </svg>
        </span>
      ))}
      <div>
        Beschermde {translate[activeGroup]?.toLowerCase()}soorten:{" "}
        {lst.map((item, index) => (
          <span key={index}>
            {index > 0 && ","} {item}
          </span>
        ))}
        {shorten && <MoreToggle open={open} setOpen={setOpen} />}
      </div>
    </div>
  );
};
export const BESI = ({ data }: { data?: string[] }) => {
  if (!data?.length) return null;
  if (typeof data == "string") data = [data];
  const result = {};
  for (const item of data) {
    const group = mapping[item];
    if (!result[group]) result[group] = [];
    result[group].push(item);
  }
  return (
    <div>
      <div hidden dangerouslySetInnerHTML={{ __html: spriteSymbols }} />
      <SoortToggle data={result} />
    </div>
  );
};
